import React from "react";
import { Icon } from "@/components/Icon";

/* LeagueSection — a league card with a collapsible header whose grid matches the
   GameMarketRow grid so the SPREAD / TOTAL / MONEYLINE column labels line up over
   the price cells (design, README §2.3). Rows are passed as children and divided
   by a 1px hairline. */

export default function LeagueSection({
  sportIcon = "all-sports", league, games = 0, live = 0, spreadTitle = "SPREAD",
  collapsed = false, onToggle, mobile = false, children, testid,
}) {
  const grid = mobile ? "minmax(0,1fr) repeat(3,64px)" : "minmax(0,1fr) repeat(3,112px)";
  const cg = mobile ? 5 : 8;
  const colLabel = (t) => (
    <span style={{ font: "700 10px Outfit", letterSpacing: ".16em", color: "#8A8A93", textAlign: "center", whiteSpace: "nowrap" }}>{t}</span>
  );
  const spreadLabel = mobile ? (spreadTitle === "SPREAD" ? "SPREAD" : spreadTitle.replace("LINE", "LN")) : spreadTitle;
  return (
    <div
      data-testid={testid}
      style={{
        background: "linear-gradient(145deg, hsl(var(--ink-700)) 0%, hsl(var(--surface-3)) 45%, hsl(var(--ink-800)) 100%)",
        borderRadius: 18, overflow: "hidden",
        boxShadow: "inset 0 1px 0 hsl(var(--edge-light)), inset 0 -1px 0 hsl(var(--edge-dark)), var(--elev-2)",
        border: "1px solid hsl(var(--surface-border))",
      }}
    >
      {/* header */}
      <button
        type="button"
        onClick={onToggle}
        data-testid={testid ? `league-header-${testid}` : undefined}
        style={{
          width: "100%", height: mobile ? 40 : 50, background: "#0F0F12", borderBottom: "1px solid #1A1A1E",
          display: "grid", gridTemplateColumns: grid, columnGap: cg, alignItems: "center",
          padding: mobile ? "0 12px" : "0 20px", cursor: "pointer", textAlign: "left",
        }}
      >
        <span style={{ minWidth: 0, display: "flex", alignItems: "center", gap: 8, overflow: "hidden" }}>
          <Icon name={collapsed ? "chevron-right" : "chevron-down"} size={14} className="shrink-0 text-[#71717a]" />
          <span style={{ width: 16, height: 16, flex: "none", background: "#a1a1aa", WebkitMask: `url(/icons/${sportIcon}.svg) center/contain no-repeat`, mask: `url(/icons/${sportIcon}.svg) center/contain no-repeat` }} />
          <span style={{ font: "800 14px Manrope", letterSpacing: ".1em", color: "#fff", textTransform: "uppercase", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{league}</span>
          {!mobile && (
            <span style={{ flex: "none", font: "500 12px Outfit", color: "#71717a", whiteSpace: "nowrap" }}>
              {games} game{games === 1 ? "" : "s"}{live > 0 ? ` · ${live} live` : ""}
            </span>
          )}
        </span>
        {!collapsed ? colLabel(spreadLabel) : <span />}
        {!collapsed ? colLabel("TOTAL") : <span />}
        {!collapsed ? colLabel(mobile ? "ML" : "MONEYLINE") : <span />}
      </button>
      {/* rows */}
      {!collapsed && (
        <div data-testid={testid ? `league-${testid}` : undefined}>
          {React.Children.map(children, (c, i) => (
            <div style={i > 0 ? { borderTop: "1px solid #1A1A1E" } : undefined}>{c}</div>
          ))}
        </div>
      )}
    </div>
  );
}
